export default __webpack_public_path__ + "media/achiv.e0587edb.jpg";